export const data3_2_1 = [{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: '',
    name_code: '',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: 'Total - Outlets 餐厅合计',
    name_code: 'Total_Outlets',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: 'Meeting Room Rental 会议场地设施收入',
    name_code: 'Meeting_Room_Rental',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: 'Service Charge/Others 服务费及其他收入',
    name_code: 'Service_Charge/Others',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
},{
    name: 'Total 合计',
    name_code: 'Total',
    covers: '0',
    business: '0',
    AC: '0',
    REV: '0',
    revenue: '0',
    cost: '0',
    cost_percent: '0',
    m_covers: '0',
    m_business: '0',
    m_AC: '0',
    m_REV: '0',
    m_revenue: '0',
    m_cost: '0',
    m_cost_percent: '0',
    b_covers: '0',
    b_business: '0',
    b_AC: '0',
    b_REV: '0',
    b_revenue: '0',
    b_cost: '0',
    b_cost_percent: '0',
}];




// WEBPACK FOOTER //
// ./src/components/table/5.0/5-2/data.js